import { MarketingChannel } from "@redotech/redo-billing-common/marketing-channel";
import {
  BackInStockSubscriberSchema,
  ProductNotificationStatus,
} from "@redotech/redo-model/customer-product-notification/customer-product-notification";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getBackInStockSubscribers = {
  name: "getBackInStockSubscribers" as const,
  input: z.object({
    productId: z.string(),
    variantId: z.string().optional(),
    searchQuery: z.string().optional(),
    dateFrom: z.date().optional(),
    dateTo: z.date().optional(),
    channels: z.array(createEnum(MarketingChannel)).optional(),
    statuses: z.array(createEnum(ProductNotificationStatus)).optional(),
  }),
  output: z.object({
    subscribers: z.array(BackInStockSubscriberSchema),
    totalCount: z.number(),
  }),
};
